import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Customer
      {record ? `: ${record.first_name} ${record.last_name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Customer/Title.js